/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { SponsorsProvider } from './context/SponsorsContext';
import { ProductsProvider } from './context/ProductsContext';
import { ContentProvider } from './context/ContentContext';
import { NewsProvider } from './context/NewsContext';
import './styles/admin.css';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ContentProvider>
      <ProductsProvider>
      <SponsorsProvider>
      <AuthProvider>
      <NewsProvider>
        <App />
      </NewsProvider>
      </AuthProvider>
      </SponsorsProvider>
      </ProductsProvider>
    </ContentProvider>
    <Toaster 
      position="top-right"
      toastOptions={{
        duration: 3000,
        style: {
          background: '#363636',
          color: '#fff',
        },
        success: {
          duration: 3000,
          theme: {
            primary: 'green',
            secondary: 'black',
          },
        },
        error: {
          duration: 4000,
        },
      }}
    />
  </React.StrictMode>
);